import { use } from 'react';

import { AppBarHeadingContext } from './AppBarHeadingContext';

export const useAppBarHeading = () => {
  const ctx = use(AppBarHeadingContext);

  if (ctx == null) {
    throw new Error('useAppBarHeading must be used within an AppBarHeadingContext');
  }

  return ctx;
};
